import * as React from "react";
const Cart = props => <symbol viewBox="0 0 24 24" {...props}>
    <path d="M9.5 19.75a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm8 0a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zm3.108-12.188A.749.749 0 0020 7.25H7.54l-.829-2.487A.75.75 0 006 4.25H3a.75.75 0 000 1.5h2.46l.823 2.47.01.034 1.996 5.983A.751.751 0 009 14.75h9a.751.751 0 00.712-.513l2-6a.752.752 0 00-.104-.675zM17.46 13.25H9.541l-1.5-4.5h10.918z" />
  </symbol>;
export default Cart;